import React from 'react';
import useStyles from './styles';
import { Link, Typography, useTheme } from '@material-ui/core';
import JetFontIcon, { JET_FONTICON_ALIASES } from '../JetFontIcon';
import utilStorage, {
  NotificationConsent,
} from '@src/shared/services/util-storage';
import { usePermissionConsentActions } from '@src/shared/context/permission-consent';
import { askBrowserNotificationPermission } from '@src/shared/utils';
import { useTranslation } from 'react-i18next';
import useDeviceDetect from '@src/shared/hooks/use-device-detect';

export const MessageBanner = () => {
  const classes = useStyles();
  const theme = useTheme();
  const { setPermissionConsent, setNotificationGrantType } =
    usePermissionConsentActions();
  const { t } = useTranslation();
  const requestPermission = () => {
    askBrowserNotificationPermission().then((permission) => {
      return setNotificationGrantType(permission);
    });
  };

  const { isIOS } = useDeviceDetect();

  return (
    <div>
      <div className={`${classes.messageBanner} ${isIOS ? 'IOS' : ''}`}>
        <div className={classes.messageBannerLeft}>
          <JetFontIcon
            color={theme.palette.jet?.supportInfo}
            size={16}
            iconname={JET_FONTICON_ALIASES.INFO_MARKER}
          />
        </div>
        <div className={classes.messageBannerContent}>
          <Typography variant="body1" className="body_bold">
            {t('permission.message_banner_title')}
          </Typography>
          <Typography variant="body1" className="body_small_regular">
            <Link
              color="inherit"
              underline="always"
              onClick={requestPermission}
            >
              {t('permission.message_banner_content')}
            </Link>
          </Typography>
        </div>
        <div className={classes.messageBannerRight}>
          <JetFontIcon
            onClick={() =>
              setPermissionConsent(NotificationConsent.SHOW_NEXT_DAY)
            }
            iconname={JET_FONTICON_ALIASES.CLOSE}
          />
        </div>
      </div>
    </div>
  );
};

export default MessageBanner;
